import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GA_MEASUREMENT_ID = 'G-DTGR90NTE0';
const GA_ALLOWED_HOSTNAME = 'brno.ikariera.cz';

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

export default function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    if (window.location.hostname !== GA_ALLOWED_HOSTNAME) {
      return;
    }

    if (typeof window.gtag !== 'function') {
      return;
    }

    const pagePath = `${location.pathname}${location.search}${location.hash}`;

    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: pagePath
    });
  }, [location]);

  return null;
}
